"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillHoles = void 0;
const turf_1 = require("@turf/turf");
const canopy_cover_1 = require("../calculators/canopy-cover");
/**
 * Determine if the area of an array of points is large enough to keep.
 *
 * @param polyLoop Geometry to calculate the area of
 * @param minHoleArea Threshold for hole size
 * @returns `true` if the area is larger than `minHoleArea`
 */
function holeFilter(polyLoop, minHoleArea) {
    const areaSqM = (0, turf_1.area)((0, turf_1.polygon)([polyLoop]));
    if (areaSqM < minHoleArea) {
        return false;
    }
    return true;
}
/**
 * Removes holes smaller than `MIN_HOLE_AREA`. Updates the properties of features to
 * track canopy cover through the operation
 *
 * @param features Features to remove holes from
 * @param minHoleArea Holes smaller than this will be filled
 * @returns A feature collection with no holes smaller than the minimum hole size.
 */
function fillHoles(features, minHoleArea) {
    return (0, turf_1.featureCollection)(features.features.map((feature) => {
        const oldArea = (0, turf_1.area)(feature);
        const newCoords = [
            feature.geometry.coordinates[0],
            ...feature.geometry.coordinates.slice(1).filter((f) => holeFilter(f, minHoleArea)),
        ];
        const outFeature = {
            ...feature,
            geometry: {
                ...feature.geometry,
                coordinates: newCoords,
            },
        };
        const newArea = (0, turf_1.area)(outFeature);
        const areaChange = newArea - oldArea;
        outFeature.properties.canopyCoverProportion = (0, canopy_cover_1.calcNewCanopyCoverPercent)(oldArea, feature.properties.canopyCoverProportion, areaChange, 0.0);
        return outFeature;
    }));
}
exports.fillHoles = fillHoles;
